module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-expansion-panels', {
    staticClass: "ReportsCardExpansionPanels",
    attrs: {
      "focusable": ""
    },
    model: {
      value: (_vm.expansionPanel),
      callback: function($$v) {
        _vm.expansionPanel = $$v
      },
      expression: "expansionPanel"
    }
  }, [_c('v-expansion-panel', {
    staticClass: "CardExpansionPanel d-flex flex-column-reverse"
  }, [_c('v-expansion-panel-header', {
    staticClass: "d-flex justify-center",
    on: {
      "click": _vm.clickExpandDeviceReportPanel
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-icon', {
          staticClass: "ma-0 flex-1",
          attrs: {
            "x-large": ""
          }
        }, [_vm._v("expand_more")])]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "d-none"
  })]), _vm._v(" "), _c('v-expansion-panel-content', _vm._l((_vm.activeLocations), function(loc) {
    return _c('div', {
      key: loc.name,
      staticClass: "ma-5"
    }, [_c('CardDetails', {
      attrs: {
        "location": loc,
        "title": _vm.title
      }
    }), _vm._v(" "), (loc.details.location_comment) ? _c('p', {
      staticClass: "LocationComment subheading my-4 py-2"
    }, [_vm._v("*" + _vm._s(loc.details.location_comment))]) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('CardCircularGraphics', {
      attrs: {
        "locationName": loc.name,
        "circGraphsData": loc.circularGraphics,
        "title": _vm.title
      }
    }), _vm._v(" "), _c('CardLinearGraphics', {
      attrs: {
        "location": loc,
        "title": _vm.title
      }
    })], 1)
  }), 0)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-871ebd34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reports/CardExpansionPanel.vue
// module id = 1735
// module chunks = 0